import React from 'react';
import { motion } from 'framer-motion';
import styles from './AvatarFace.module.css';

const FACE_MAP = {
  neutral: {
    browLeft: 'M 16 20 Q 22 18 28 20',
    browRight: 'M 36 20 Q 42 18 48 20',
    mouth: 'M 22 42 Q 32 46 42 42'
  },
  happy: {
    browLeft: 'M 16 19 Q 22 17 28 19',
    browRight: 'M 36 19 Q 42 17 48 19',
    mouth: 'M 22 40 Q 32 51 42 40'
  },
  confused: {
    browLeft: 'M 16 22 Q 22 15 28 22',
    browRight: 'M 36 19 Q 42 22 48 19',
    mouth: 'M 22 43 Q 32 39 42 43'
  },
  concerned: {
    browLeft: 'M 16 23 Q 22 16 28 23',
    browRight: 'M 36 23 Q 42 16 48 23',
    mouth: 'M 22 46 Q 32 38 42 46'
  },
  surprised: {
    browLeft: 'M 16 18 Q 22 14 28 18',
    browRight: 'M 36 18 Q 42 14 48 18',
    mouth: 'M 28 41 Q 32 37 36 41'
  }
};

const AvatarFace = ({ expression = 'neutral', size = 64, accent = '#264653' }) => {
  const face = FACE_MAP[expression] || FACE_MAP.neutral;

  return (
    <svg viewBox="0 0 64 64" width={size} height={size} className={styles.face}>
      <circle cx="32" cy="32" r="28" fill="#fff" stroke="#1a1a1a" strokeWidth="2.5" />
      <circle cx="24" cy="30" r="2.8" fill={accent} />
      <circle cx="40" cy="30" r="2.8" fill={accent} />
      <motion.path d={face.browLeft} fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" animate={{ d: face.browLeft }} transition={{ duration: 0.3 }} />
      <motion.path d={face.browRight} fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" animate={{ d: face.browRight }} transition={{ duration: 0.3 }} />
      <motion.path d={face.mouth} fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" animate={{ d: face.mouth }} transition={{ duration: 0.35 }} />
    </svg>
  );
};

export default AvatarFace;
